// extracted by mini-css-extract-plugin
module.exports = {"container":"drawerEvent_container__22kU9","avatar":"drawerEvent_avatar__3UeZp","details":"drawerEvent_details__2lF0b"};